var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-list',{attrs:{"entity-name":"restaurantImage","model":_vm.model,"icon":"mdi-calendar-today"}})
}
var staticRenderFns = []

export { render, staticRenderFns }